import type { ThemeV2 } from '@modules/themes/types/themesV2.types';

/**
 * The system-theme list order everywhere the list is shown (the create wizard, the onboarding theme
 * picker): `order` ascending (themes without one last), then the newest first.
 */
export function compareThemesV2ByOrder(
  a: Pick<ThemeV2, 'order' | 'createdAt'>,
  b: Pick<ThemeV2, 'order' | 'createdAt'>,
): number {
  const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
  const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
  if (orderA !== orderB) {
    return orderA - orderB;
  }
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
